<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation class="dark bg-gray-900 print:hidden" [mode]="isScreenSmall ? 'over' : 'side'" [name]="'mainNavigation'" [navigation]="vertical" [opened]="!isScreenSmall">
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <div class="flex items-center w-full p-4 pl-6">
      <!-- Logo -->
      <div class="flex items-center justify-center">
        <img class="w-12" src="assets/images/brand/{{branding()}}/logo/logo.svg" />
      </div>
      <!-- Components -->
      <div class="flex items-center ml-auto">
        <!-- <notifications></notifications> -->
        <user [showAvatar]="false"></user>
      </div>

      <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
        <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
      </button>
    </div>
  </ng-container>
  <!-- Navigation footer hook -->
  <ng-container fuseVerticalNavigationFooter>
    <div class="flex flex-0 items-center justify-center h-16 pr-6 pl-2 mt-2 mb-2 opacity-30">
      <img class="max-w-36" src="assets/images/brand/{{branding()}}/logo/logo-text-on-dark.svg" />
    </div>
  </ng-container>
</fuse-vertical-navigation>

<div class="absolute flex flex-0 items-center w-full h-16 px-2 z-90 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
  <!-- Navigation toggle button -->
  <button mat-icon-button (click)="toggleNavigation1('mainNavigation')">
    <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
  </button>
</div>

<div class="flex flex-col flex-auto w-full min-w-0">
  <!-- Header -->
  <div class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 shadow dark:shadow-none dark:border-b bg-card bg-transparent print:hidden">
    <!-- Navigation toggle button -->

    <!-- Components -->
    @if (!hideSearch) {

    <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2 z-90">
      <search [appearance]="'bar'"></search>
    </div>
    }
  </div>

  <!-- Content -->
  <div class="flex flex-col flex-auto">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
    @if (true) {
    <router-outlet></router-outlet>
    }
  </div>
</div>
